<template>
  <div class="l-contentmain contentmain">
    <page-nav-bar
      v-if="u"
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <router-link :to="{ name: 'UserList'}">
            Utilisateurs
          </router-link>
        </h1>
        <div class="page-header-breadcrumb-separator" />
        <div class="page-header-breadcrumb-item">
          <span class="has-text-weight-normal has-text-grey-dark">Mon compte</span>
        </div>
      </template>
    </page-nav-bar>
    <spinner-round
      v-if="loading"
      :is-loading="loading" />
    <page-content
      v-else-if="u && !loading"
      :has-left-col-small="true"
      :has-left-col-small-size-fixed="false"
      :has-sticky-col-left="true">
      <template slot="left-col-small">
        <div class="has-background-white is-border">
          <div class="is-padding-top is-padding-left is-padding-right is-padding-bottom-small has-text-centered">
            <figure
              class="image is-128x128 is-margin-auto has-vadPicto has-picto--top2Right"
              @mouseover="userAvatarHover = true"
              @mouseleave="userAvatarHover = false">
              <router-link
                data-tooltip="Editer la fiche"
                class="dot is-large has-background-light--darken3 has-text-white is-border is-border--white tooltip is-tooltip-right"
                :to="{name: 'ProfilInfo', params: {id: user.pk}}">
                <span class="icon"><i class="fas fa-pen" /></span>
              </router-link>
              <div class="is-border is-border--circle is-clipped">
                <upload-file
                  :source-documents="[user.picture]"
                  :is-avatar="true"
                  :show-list="false"
                  class="is-border--circle is-clipped"
                  :label-class="''"
                  @upload="uploadUserAvatar($event)" />
              </div>
            </figure>
            <div
              v-if="user && user.last_name && user.first_name"
              class="title is-3 is-margin-top-xsmall is-marginless-bottom">
              <b id="userName">{{ user.last_name }} {{ user.first_name }}</b>
            </div>
            <div
              v-if="user.profil"
              class="is-size-5 has-text-weight-light">
              <span v-if="isAdminReferent">Référent</span>
              <span v-else-if="user.profil === 'admin'">Administrateur</span>
              <span v-else>
                {{ user.profil | profilTypeLabel }}
              </span>
              <span v-if="user.account && !(currentUser.account.pk === user.account.pk)">
                chez <b>
                  <router-link
                    v-if="(isAdmin || isManager)"
                    :to="{name: 'CompanyVue', params: {id: user.account.pk}}">{{ user.account.name }}
                  </router-link>
                  <span v-else>{{ user.account.name }}</span>
                </b>
              </span>
            </div>
          </div>
          <div
            v-if="user.profil && user.profil === 'seller'"
            class="is-padding is-border-top">
            <div class="columns is-multiline">
              <div class="column is-12 columns is-column is-space-between">
                <div class="has-text-grey is-size-6">
                  Manager
                </div>
                <div class="is-size-5">
                  <router-link
                    v-if="user.manager && (isAdmin || isManager)"
                    :to="{name: 'UserVue', params: {id: user.manager.pk || user.manager}}">
                    <span v-if="'last_name' in user.manager && 'first_name' in user.manager && user.manager.last_name && user.manager.first_name"><b>{{ user.manager.last_name }} {{ user.manager.first_name }}</b></span>
                  </router-link>
                  <span v-else-if="user.manager && 'last_name' in user.manager && 'first_name' in user.manager && user.manager.last_name && user.manager.first_name && user.profil === 'seller'"><b>{{ user.manager.last_name }} {{ user.manager.first_name }}</b></span>
                  <span v-else>Aucun manager <span v-if="isAdmin && currentUser.account.pk === user.account.pk">: <a
                    class="is-underline"
                    @click="openManagerSelectionModal"> Spécifier manager</a></span></span>
                </div>
              </div>
            </div>
          </div>
          <aside class="menu menu--admin menu--admin--notFat is-border-top">
            <ul class="menu-list has-background-white">
              <li :class="{'is-active':['UserTab'].includes($route.name) && !isActiveNotification}">
                <router-link :to="{name: 'UserTab', params: {id: currentUser.pk}}">
                  <span><span class="icon is-medium is-margin-right"><i class="far fa-user" /></span>Tableau de bord</span>
                </router-link>
              </li>
              <li :class="{'is-active' :$route.name === 'ProfilInfo' && !isActiveNotification}">
                <router-link :to="{name: 'ProfilInfo', params: {id: currentUser.pk}}">
                  <span><span class="icon is-medium is-margin-right"><i class="far fa-user-edit" /></span>Informations personnelles</span>
                </router-link>
              </li>
              <li :class="{'is-active' :$route.name === 'ProfilChangePassword' && !isActiveNotification}">
                <router-link :to="{name: 'ProfilChangePassword', params: {id: currentUser.pk}}">
                  <span><span class="icon is-medium is-margin-right"><i class="far fa-lock-alt" /></span>Mot de passe</span>
                </router-link>
              </li>
              <li :class="{'is-active' : isActiveNotification}">
                <a @click="manageNotifications"><span><span class="icon is-medium is-margin-right"><i class="far fa-bell" /></span>Notifications</span></a>
              </li>
              <li class="has-background-white-ter">
                <a @click="logout()"><span><span class="icon is-medium is-margin-right"><i class="far fa-sign-out-alt" /></span>Déconnexion</span></a>
              </li>
            </ul>
          </aside>
        </div>
      </template>
      <div class="has-background-white is-border">
        <router-view :key="$route.name" />
      </div>
    </page-content>
  </div>
</template>

<script>
import { User, DefaultValues, Quickview } from '@/mixins'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'Profil',
  mixins: [User, DefaultValues, Quickview],
  data () {
    return {
      isActiveNotification: false,
      userAvatarHover: false
    }
  },
  computed: {
    ...mapState(['quickview']),
    ...mapGetters(['isAdmin', 'isPromoteur']),
    isAdminReferent () {
      return this.user.first_admin
    }
  },
  watch: {
    '$route.name' (value, oldValue) {
      if (value !== oldValue) {
        this.initProfilTab()
      }
    },
    quickview ({ mode, params, results, close }) {
      if (results && mode === 'MANAGE_NOTIFICATION') {
        this.isActiveNotification = false
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        this.$emit('updateUser', results.results)
      }
      if (close) {
        this.isActiveNotification = false
      }
      if (results && mode === 'USER_SELECTION' && this.user.profil === 'seller') {
        if (results.entities.length) {
          this.$emit('updateManager', results.entities[0])
        } else {
          this.$toasted.global.danger('Veuillez séléctionner un manager')
        }
      }
    }
  },
  created () {
    this.initProfilTab()
  },
  methods: {
    async initProfilTab () {
      let tabs = ['UserTab', 'ProfilInfo', 'ProfilChangePassword']
      if (!tabs.includes(this.userView)) {
        await this.$router.replace({ name: 'UserTab' })
      }
      if ('tab' in this.$route.query && this.$route.query.tab === 'notification') {
        await this.manageNotifications()
      }
    },
    async manageNotifications () {
      this.isActiveNotification = true
      this.openUserNotificationQuickview()
    },
    /** Logout and redirect to referrer if entrypoint is white label login */
    logout () {
      this.$store.commit('logout')
      window.localStorage.removeItem('token')
      const referrer = localStorage.getItem('referrer')
      if (referrer) {
        window.localStorage.clear()
        window.location = referrer
      } else {
        this.$router.replace({ name: 'Login' })
        window.localStorage.clear()
      }
    }
  }
}
</script>
